<!--
  动态 banner背景图，默认背景图名称 banner-index
-->
<template>
  <div class="specialBgc" :style="{height: `${height}px`}">
    <template v-if="!logoError && EnterpriseId">
      <img class="bgcImg" :src="logoUrl" @error="()=>{ logoError = true }" alt=""/>
    </template>
    <template v-else>
      <img class="bgcImg" src="@/assets/images/banner-index.jpg" alt="">
    </template>
  </div>
</template>

<script>
export default {
  name: "CommonBgc",
  data() {
    return {
      logoUrl: '',
      logoError: false
    }
  },
  props: {
    imgName: {
      type: String,
      default: () => 'index'
    },
    height: {
      type: Number,
      default: () => 180
    }
  },
  watch: {
    EnterpriseId: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val) {
          this.logoUrl = `${location.origin}/infoplus/file/enterprise/${val}/icon/banner-${this.imgName}`;
        }
      }
    }
  },
  computed: {
    EnterpriseId() {
      if (this.$store.getters.getUserInfo.enterprise) {
        return this.$store.getters.getUserInfo.enterprise.id;
      } else {
        return '';
      }
    }
  }
}
</script>
<style lang="less" scoped>
.specialBgc {
  width: 100%;

  .bgcImg {
    width: 100%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/todoCenter/banner.vue